module.exports = __webpack_public_path__ + "media/images/home/rentabilidade__-e61161c80526832b7db0abc31e1a6a66.png";